module.exports = __webpack_public_path__ + "assets/places_black.1a62305a.svg";